<template>
  <div>
    <vue-loading type="bars" color="#F87653" :size="{ width: '50px', height: '50px' }"></vue-loading>
  </div>
</template>
<script>
import { VueLoading } from 'vue-loading-template'
export default {
  name: 'Loading',
  components: {
    VueLoading
  }
}
</script>
